import React from 'react';
import {
  BucketCardColors,
  BucketInteractionState,
  InvoiceSummaryBucketCardBase,
} from '@finance-hub/domain/invoicing/components/invoice-summary-bucket-card-base';
import { getInvoiceSummaryAmountSize } from '@finance-hub/domain/invoicing/blocs/utils/invoice-summary-amount-size-utils';
import {
  InvoiceSummaryTimeSeriesBucket,
  InvoiceSummaryTimeSeriesVariant,
} from '@finance-hub/domain/invoicing/blocs/types/invoice-summary';

export const TIME_SERIES_BUCKET_MIN_WIDTH = 116;

const AMOUNT_SIZE_CEILING = '$lg';

interface Props extends Omit<InvoiceSummaryTimeSeriesBucket, 'filter'> {
  interactionState: BucketInteractionState;
  longestAmountLength: number;
  onPress: () => void;
}

const COLORS_BY_VARIANT: Record<
  InvoiceSummaryTimeSeriesVariant,
  BucketCardColors
> = {
  critical: {
    activeBorderColor: '$textError',
    backgroundColor: '$red5',
    borderColor: '$red5',
    countColor: '$textError',
    labelColor: '$textError',
    textColor: '$textError',
  },
  current: {
    activeBorderColor: '$textSuccess',
    backgroundColor: '$green3',
    borderColor: '$green3',
    countColor: '$textSuccess',
    labelColor: '$textSuccess',
    textColor: '$textSuccess',
  },
  error: {
    activeBorderColor: '$textError',
    backgroundColor: '$red3',
    borderColor: '$red3',
    countColor: '$textError',
    labelColor: '$textError',
    textColor: '$textError',
  },
  warning: {
    activeBorderColor: '$textWarning',
    backgroundColor: '$bgHighlightWarningPrimary',
    borderColor: '$bgHighlightWarningPrimary',
    countColor: '$textWarning',
    labelColor: '$textWarning',
    textColor: '$textWarning',
  },
};

/** An aging breakdown card (Current / 0–14D / … / 90D+). */
export const InvoiceSummaryTimeSeriesBucketCard: React.FC<Props> = ({
  longestAmountLength,
  variant,
  ...cardProps
}) => {
  return (
    <InvoiceSummaryBucketCardBase
      {...cardProps}
      amountSize={getInvoiceSummaryAmountSize(
        longestAmountLength,
        AMOUNT_SIZE_CEILING,
      )}
      colors={COLORS_BY_VARIANT[variant]}
      minWidth={TIME_SERIES_BUCKET_MIN_WIDTH}
    />
  );
};
